export const getPercentageValue = (
  value: number,
  percentage: number,
): number => {
  if (!Number.isFinite(value) || !Number.isFinite(percentage)) return value;

  return (value / 100) * percentage;
};
